export const Status = { /* todo: convert to enum (typescript) */
	400: "Validation",
	401: "Unauthorized",
	403: "Forbidden",
	404: "NotFound",
	500: "Server"
};